module.exports = __webpack_public_path__ + "img/w16-cover.5b090d96.jpg";